import { render, staticRenderFns } from "./PropertyReadOnlyInf.vue?vue&type=template&id=78ec586a&scoped=true"
import script from "./PropertyReadOnlyInf.vue?vue&type=script&lang=js"
export * from "./PropertyReadOnlyInf.vue?vue&type=script&lang=js"
import style0 from "./PropertyReadOnlyInf.vue?vue&type=style&index=0&id=78ec586a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ec586a",
  null
  
)

export default component.exports